import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberToAlphabet'
})
export class NumberToAlphabetPipe implements PipeTransform {
  transform(n: number): string {
    if (typeof n !== 'number') return null;
    if (n > 255) throw new Error('cannot go over 255');
    let a = 'A'.charCodeAt(0);
    let answer = Math.floor(n / 26);
    let remainder = Math.floor(n % 26);
    return (answer !== 0 ? String.fromCharCode(a + answer):'') + String.fromCharCode(a + remainder);    
  }

}


